<template>
  <NavigationBar title="Cobertura Universal"></NavigationBar>

  <div class="banner-principal">
    <img
      class="img-fluid img-header"
      alt="Banner principal"
      src="@/assets/site/banner-up.png"
    />
  </div>

  <div>
    <router-view />
  </div>

  <Footer copyright="Servicios de Salud de Nuevo León &copy; 2022"></Footer>
</template>

<style>
/* Import MaterialDesign Icons CDN {global scope}*/
@import "https://cdn.jsdelivr.net/npm/@mdi/font@6.5.95/css/materialdesignicons.min.css";

#nav {
  padding: 15px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.img-header {
  max-height: 400px;
}

#app .container {
  max-width: 100%;
}

#app{
  font-family: 'branding_sfsemibold';
}

.banner-principal{
  width: 100%;
  text-align: center;
  margin-top: 70px;
  background-color: #00A9E0;
}
</style>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavComponents/NavigationBar.vue";
import Footer from "@/components/NavComponents/Footer.vue";

export default {
  name: "App",
  components: {
    NavigationBar,
    Footer,
  },
};
</script>
